import $ from 'jquery';

export function initAnalytics() {

    $("[data-title] a").on("click", function (e) {

        var $this = $(this);
        var url = $this.attr("href");
        var label = $this.parents("[data-title]").attr("data-title") || $this.attr("data-title");
        var category = $this.parents("[data-title]").attr("data-cluster");

        if (gtag) {
            gtag('event', 'click', {
                'event_category': category,
                'event_label': label,
                'transport_type': 'beacon',
                'event_callback': function () {
                }
            });
        }

    });

}

